import React, { useEffect, useState, useMemo } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import FormWrapper from "../../FormWrapper";
import {
  getObjectiveDetailById,
  getObjectivesListItems,
} from "../../../../redux/SystemManager/objectives";
import { useToastMessage } from "../../../../components/ToastMessage/ToastMessage";
import { Toaster } from "@fluentui/react-components";
import { FormLoader } from "../../../../components/Loader/FormLoader";
import { TableListLoader } from "../../../../components/Loader/TableListLoader";
import ListWrapper from "../../ListWrapper";
import { configFm } from "../../../../types";
const FORM_CONTEXT = "MASTER_SETTINGS_OBJECTIVES";
const API_BASE_PATH = "/system-manager/customisations/objectives";
function ObjectivesDetailPage() {
  const { itemId, action } = useParams();
  const location = useLocation();
  const { showToast, toasterId } = useToastMessage();
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const { activeItem, listItems, loading, activeItemloading } = useSelector(
    (state: RootState) => state.objectives
  );
  const formSettingsObj = useSelector((state: RootState) => state.formSettings);
  const [configForm, setConfigForm] = useState<configFm>();
  const [currentRecord, setCurrentRecord] = useState(1);
  useEffect(() => {
    dispatch(getObjectivesListItems());
  }, [dispatch]);
  useEffect(() => {
    if (listItems.length > 0 && itemId) {
      dispatch(getObjectiveDetailById(itemId));
    }
  }, [listItems, itemId, dispatch]);
  useEffect(() => {
    if (
      formSettingsObj?.systemAdmin &&
      formSettingsObj.systemAdmin.formConfig !== undefined
    ) {
      let configObj = formSettingsObj.systemAdmin.formConfig.find(
        (item: any) => item.context === FORM_CONTEXT
      );
      if (configObj) {
        setConfigForm(configObj);
      }
    }
  }, [formSettingsObj]);

  const loadData = async (
    dispatch: AppDispatch,
    id?: string
  ): Promise<void> => {
    await dispatch(getObjectivesListItems());
    if (id) {
      await dispatch(getObjectiveDetailById(id));
    }
  };
  const hasListItems = useMemo(() => listItems.length > 0, [listItems]);
  return (
    <>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      <div className="admin_container_flex">
        {action &&
          (activeItemloading ? (
            <FormLoader />
          ) : (
            <FormWrapper
              dataList={listItems}
              context={FORM_CONTEXT}
              reloadData={loadData}
              selectedRowItem={activeItem}
              config={configForm}
              action={action || "view"}
              apiPath={API_BASE_PATH}
              notify={showToast}
              activeRow={currentRecord}
            />
          ))}

        {loading ? (
          <TableListLoader rows={8} columns={6} />
        ) : (
          hasListItems &&
          action &&
          listItems.length > 0 && (
            <ListWrapper
              data={listItems}
              context={FORM_CONTEXT}
              selectedRowItem={activeItem}
              onRowAction={(action, row) =>
                navigate(`${API_BASE_PATH}/${row?.id}/${action || "view"}`)
              }
              currentRecord={(index) => setCurrentRecord(index)}
            />
          )
        )}
      </div>
    </>
  );
}

export default ObjectivesDetailPage;
